<template>
  <div></div>
</template>

<script>
import util from "@/util/util";

export default {
  name: "xtkReadTrk",
  mounted() {
    this.initPage();
  },
  methods:{
    initPage(){
      var r = new window.X.renderer3D();
      r.init();
      r.camera.position = [0, 400, 0];
      var fibers = new window.X.fibers();
      fibers.file = util.baseUrl + "FA_FACT_45_02_1_0_S.trk";
      r.add(fibers)
      r.render();
    }
  }
}
</script>

<style scoped>
html, body {
  background-color:#000;
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden !important;
}
</style>